import { RouteConfig } from 'react-router-config'

export enum PageType {
  HOME = 'home',
  FEATURE = 'feature',
  POPULAR = 'popular',
  CATEGORY = 'category',
  TAG = 'tag',
  ATTRIBUTE = 'attribute',
  SEARCH = 'search',
  LANDING = 'landing',
  OTHER = 'other'
}

export interface IRouteConfig extends RouteConfig {
  pageType?: PageType
  routes?: IRouteConfig[]
}
